import { JwtPayload } from 'jwt-decode';
import { User } from '../../types/auth';

export const RESUME_HUBSPOT_SESSION_SUCCESS = 'RESUME_HUBSPOT_SESSION_SUCCESS';
export const RESUME_SESSION_SUCCESS = 'RESUME_SESSION_SUCCESS';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export interface AuthState {
  authenticated: boolean;
  accessToken?: string;
  referralCode?: string;
  user?: User;
  hubspotToken?: string;
}

export interface DecodedToken extends JwtPayload {
  user: User;
}
